import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'

const languages = ['en', 'cn', 'zhHK'];
var langs =  localStorage.getItem("lang")
const lang = languages.includes(langs) ? langs : 'cn';

i18n.use(initReactI18next).init({
    fallbackLng: lang,
    lng: lang,
    resources: {
        en: {
            translations: require('./locales/en/translations.json')
        },
        cn: {
            translations: require('./locales/cn/translations.json')
        },
        zhHK: {
            translations: require('./locales/zh-HK/translations.json')
        }
    },
    ns: ['translations'],
    defaultNS: 'translations'
});

i18n.languages = ['en', 'cn', 'zhHK']

export default i18n;